import { render, staticRenderFns } from "./ExpenseStats.vue?vue&type=template&id=33c92198"
import script from "./ExpenseStats.vue?vue&type=script&lang=js"
export * from "./ExpenseStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports